import { createTheme } from "@mui/material/styles";
import "./muiTypes.d.ts";
import { colors } from "./colors";

const theme = createTheme({
  palette: {
    text: colors.text,
    background: colors.background,
    primary: colors.primary,
    secondary: colors.secondary,
    status: colors.status,
    amber: colors.amber,
    border: colors.border,
    shadow: colors.shadow,
  },
  typography: {
    fontFamily: '"Sora", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h2: {
      fontSize: 26,
    },
    h6: {
      fontSize: 13,
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 12,
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          opacity: 0.5,
          backgroundColor: colors.border.medium,
          borderColor: colors.border.medium,
          borderWidth: "0.5px",
          borderStyle: "solid",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 14,
          color: colors.text.primary,
        },
        h1: {
          fontFamily: "Sora",
          fontSize: 26,
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "32px",
        },
        h2: {
          fontSize: 26,
        },
        h4: {
          fontWeight: "bold",
        },
        h5: {
          fontWeight: "bold",
          fontSize: 18,
        },
        h6: {
          opacity: 0.5,
          fontSize: 13,
        },
        body2: {
          fontSize: 12,
        },
        subtitle1: {
          fontSize: 12,
        },
        subtitle2: {},
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F5F9FD",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          padding: "8px",
          background: colors.background.default,
          borderRadius: "8px",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: "5px 0",
          gap: 16,
          fontSize: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          fontSize: "16px",
          fontFamily: "Nunito",
          fontWeight: 700,
          paddingLeft: "24px",
          height: "48px",
          paddingRight: "24px",
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:focus": {
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            color: colors.text.secondary,
            backgroundColor: colors.border.light,
            "&.MuiButton-contained": {
              backgroundColor: colors.border.light,
              color: colors.text.secondary,
            },
            "&.MuiButton-outlined": {
              borderColor: colors.border.light,
              color: colors.text.secondary,
              backgroundColor: colors.background.secondary,
            },
            "&.MuiButton-text": {
              color: colors.text.secondary,
              backgroundColor: "transparent",
            },
          },
        },
        contained: {
          backgroundColor: colors.amber.main,
          color: colors.background.secondary,
          "&:hover": {
            backgroundColor: colors.amber.dark,
            boxShadow: "none",
          },
          "&:focus": {
            backgroundColor: colors.amber.dark,
            boxShadow: "none",
          },
        },
        dashed: {
          border: `1px dashed ${colors.primary.main}`,
          color: colors.primary.main,
          backgroundColor: colors.background.secondary,
          "&:hover": {
            borderColor: colors.primary.dark,
            color: colors.primary.dark,
          },
        },
        outlined: {
          borderColor: colors.primary.main,
          color: colors.primary.main,
          backgroundColor: colors.background.secondary,
          "&:hover": {
            borderColor: colors.primary.dark,
            color: colors.primary.dark,
            backgroundColor: colors.background.lightBlue,
            boxShadow: "none",
          },
          "&:focus": {
            borderColor: colors.primary.dark,
            color: colors.primary.dark,
            backgroundColor: colors.background.lightBlue,
            boxShadow: "none",
          },
        },
        text: {
          color: colors.primary.main,
          backgroundColor: "transparent",
          "&:hover": {
            color: colors.primary.dark,
            backgroundColor: colors.background.lightBlue,
            boxShadow: "none",
          },
          "&:focus": {
            color: colors.primary.dark,
            backgroundColor: colors.background.lightBlue,
            boxShadow: "none",
          },
        },
        sizeSmall: {
          height: "40px",
          fontSize: "14px",
          fontWeight: 700,
          paddingLeft: "16px",
          paddingRight: "16px",
        },
        sizeExtraSmall: {
          height: "32px",
          fontSize: "14px",
          fontWeight: 700,
          paddingLeft: "10px",
          paddingRight: "10px",
        },
      },
    },
  },
});

export default theme;
